var exports = {
  "fs": "VisualTab.module__sliderSection___bVl1ZT",
  "Ry": "VisualTab.module__sliderHeader___bVl1ZT",
  "mr": "VisualTab.module__sliderTitleRow___bVl1ZT",
  "KF": "VisualTab.module__sliderLabel___bVl1ZT",
};

module.exports = exports;
